import { render, staticRenderFns } from "./Tpv.vue?vue&type=template&id=9b7bdb88"
import script from "./Tpv.vue?vue&type=script&lang=js"
export * from "./Tpv.vue?vue&type=script&lang=js"
import style0 from "./Tpv.vue?vue&type=style&index=0&id=9b7bdb88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports